import React, { Component } from 'react'
import cx from 'classnames'
import Header from '../components/header'
import NavMenu from '../components/navMenu'
import Footer from '../components/footer'
import Routes from '../routes'
import './app.css'

class App extends Component {
  render() {
    return (
      <main className={cx('app-container')}>
        <Header />
        <NavMenu />
        {/* Page Content included via Routes component */}
        <Routes />
        <Footer />
      </main>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/client/containers/app.js